import React, { useState } from 'react';
import '../styles/ActivateNow.css';

function ActivateNow() {
  const [activationCode, setActivationCode] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsProcessing(true);
    console.log('Activation code submitted:', activationCode);
    
    // Simulate processing time
    setTimeout(() => {
      setIsProcessing(false);
      setIsSubmitted(true);
    }, 2000);
  };

  if (isProcessing) {
    return (
      <div className="modal-overlay" style={{ 
        backgroundColor: 'rgba(70, 130, 180, 0.9)',
        backdropFilter: 'blur(8px)',
        WebkitBackdropFilter: 'blur(8px)',
        padding: '20px'
      }}>
        <div className="modal-content" style={{
          background: 'linear-gradient(135deg, #ffffff 0%, #e1f5fe 100%)',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          width: '100%',
          maxWidth: '500px',
          margin: '0 auto',
          padding: '20px',
          borderRadius: '12px',
          textAlign: 'center'
        }}>
          <h2>Processing Your Code</h2>
          <div style={{
            margin: '30px 0',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            gap: '15px'
          }}>
            <div className="loading-spinner" style={{
              width: '40px',
              height: '40px',
              border: '4px solid #f3f3f3',
              borderTop: '4px solid #007bff',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite'
            }}></div>
            <p>Please wait while we verify your code...</p>
          </div>
        </div>
      </div>
    );
  }

  if (isSubmitted) {
    return (
      <div className="modal-overlay" style={{ 
        backgroundColor: 'rgba(70, 130, 180, 0.9)',
        backdropFilter: 'blur(8px)',
        WebkitBackdropFilter: 'blur(8px)',
        padding: '20px'
      }}>
        <div className="modal-content" style={{
          background: 'linear-gradient(135deg, #ffffff 0%, #e1f5fe 100%)',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          width: '100%',
          maxWidth: '500px',
          margin: '0 auto',
          padding: '20px',
          borderRadius: '12px',
          textAlign: 'center'
        }}>
          <h2>Your Code has been submitted successfully</h2>
          <h3>Call Us Now to Activate</h3>
          <a href="tel:7867538470" className="call-button" style={{
            display: 'inline-block',
            padding: '15px 30px',
            fontSize: '20px',
            backgroundColor: '#007bff',
            color: 'white',
            textDecoration: 'none',
            borderRadius: '8px',
            margin: '20px 0'
          }}>
            Call (786) 753-8470
          </a>
          <p>CLICK TO CALL</p>
        </div>
      </div>
    );
  }

  return (
    <div className="modal-overlay" style={{ 
      backgroundColor: 'rgba(70, 130, 180, 0.9)',
      backdropFilter: 'blur(8px)',
      WebkitBackdropFilter: 'blur(8px)',
      padding: '20px'
    }}>
      <div className="modal-content" style={{
        background: 'linear-gradient(135deg, #ffffff 0%, #e1f5fe 100%)',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        width: '100%',
        maxWidth: '500px',
        margin: '0 auto',
        padding: '20px',
        borderRadius: '12px'
      }}>
        <h1>Setup Your Device</h1>
        <h2>Connect a Device!</h2>

        <form onSubmit={handleSubmit}>
          <div className="activation-section">
            <h3>Enter the code displayed on your TV screen</h3>
            <input
              type="text"
              value={activationCode}
              onChange={(e) => setActivationCode(e.target.value)}
              placeholder="Enter activation code"
            />
            <button type="submit">Submit</button>
          </div>
        </form>

        <div className="divider">
          <span>OR</span>
        </div>

        <div className="call-section">
          <h3>Activate your device without code</h3>
          <a href="tel:7867538470" className="call-button">
            Call (786) 753-8470
          </a>
          <p>Click above to call now</p>
        </div>
      </div>
    </div>
  );
}

export default ActivateNow; 